import React, { Fragment } from "react";
import Navbar from "components/header/navbar";
import Sidebar from "components/sidebar/sidebar";
import SubNavbarWrapper from "components/header/subNavbarWrapper";
import Footer from "components/footers/footer";
import ContentWrapper from "components/body/contentWrapper";
import SubNavbar from "components/header/subNavbar";

const Layout = ({ children, subnavbar }) => {
  return (
    <Fragment>
      <div className="background-dark"></div>
      <Navbar />
      <Sidebar />
      <SubNavbarWrapper>
        <SubNavbar {...subnavbar} />
      </SubNavbarWrapper>
      <ContentWrapper>{children}</ContentWrapper>
      <Footer />
    </Fragment>
  );
};

export default Layout;
